export default __webpack_public_path__ + "static/media/icon-facebook.b97201c3.svg";